import React from 'react'
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from 'react-redux';
import WrappedModal from '@/components/WrappedModal'
import StoreForm from './StoreForm'

class StoreModal extends React.Component {
  state = {
    baseComponent: '',
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : 1920, // 默认宽
    windowHeight: typeof window !== 'undefined' ? window.innerHeight : 1080 // 默认高
  }
  static propTypes = {
    baseProps: PropTypes.object,
    title: PropTypes.string,
    width: PropTypes.number
  }

  componentDidMount() {
    // 组件挂载时获取窗口大小
    this.handleResize();
    // 添加窗口大小变化监听器
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    // 组件卸载时移除监听器
    window.removeEventListener('resize', this.handleResize);
  }

  // 处理窗口大小变化
  handleResize = () => {
    if (typeof window !== 'undefined') {
      this.setState({
        windowWidth: window.innerWidth,
        windowHeight: window.innerHeight
      });
    }
  }

  // 根据窗口大小计算模态框合适的尺寸
  getModalDimensions = () => {
    const { windowWidth, windowHeight } = this.state;
    const { width: propsWidth } = this.props;

    // 如果用户传入了固定宽度，则使用传入的宽度
    if (propsWidth) {
      return { width: propsWidth };
    }

    // 否则根据窗口宽度按比例计算
    // 大屏幕：宽度占70%
    // 中屏幕：宽度占80%
    // 小屏幕：宽度占90%
    let calculatedWidth;
    if (windowWidth >= 1600) {
      calculatedWidth = windowWidth * 0.7;
    } else if (windowWidth >= 1200) {
      calculatedWidth = windowWidth * 0.8;
    } else {
      calculatedWidth = windowWidth * 0.9;
    }

    return {
      width: Math.min(calculatedWidth, 1200), // 最大宽度不超过1200px
      // 可以根据需要添加高度计算逻辑
    };
  }

  handleOk = async (form) => {

  }

  render () {
    const { children, baseProps, title } = this.props
    const modalDimensions = this.getModalDimensions();
    const baseComponent = (
      <StoreForm/>
    );
    return (
      <WrappedModal
        children={children}
        baseProps={{ ...baseProps }}
        baseComponent={baseComponent}
        title={title}
        width={modalDimensions.width}
        onOk={this.handleOk}
        centerTitle
        className={`modal-style-dark center-title-modal`}
      />
    )
  }
}
// 使用函数组件作为wrapper来使用React Redux Hooks，然后传递给类组件
const VisualDashboardWrapper = (props) => { // 接收所有props
  const dispatch = useDispatch();
  // 修复数据选择逻辑
  const enhancedProps = {
    dispatch,
    storeObj: useSelector(state => state.dashboard.storeList || {}),
    ...props // 传递所有接收到的props，包括children
  }
  return <StoreModal {...enhancedProps}/>;
};

export default VisualDashboardWrapper;